<template>
  <div class="home">
      <panel-group />
      <chart height="72%" width="100%" />
  </div>
</template>

<script>
import PanelGroup from './components/PanelGroup';
import Chart from '@/components/Charts/MixChart'

export default {
  name: 'MixChart',
  components: {
    PanelGroup,
    Chart
  },
  created() {
    document.title = 'BOSS后台管理系统-蜂巢能源科技有限公司'
  }
}
</script>

<style scoped>
.home{
  position: relative;
  width: 100%;
  height: calc(100vh - 84px);
}
</style>



// WEBPACK FOOTER //
// src/views/boss/home/index.vue